export interface WelcomeModel {
  surveyName: string;
  companyName: string;
  welcomeText: string;
  welcomeImage: string;
}
